import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import robloxApi from '../../api/robloxApi';
import { ReportInterface } from "../../store/roblox/reportsSlice";
import { usersEntity } from "./usersActions";
import { skinEntity, skinsEntity } from "./skinsActions";
import { UserInterface} from "../../store/roblox/usersSlice";
import { SkinInterface } from "../../store/roblox/skinsSlice";
import { CommentInterface } from "../../store/roblox/commentsSlice";
import { commentEntity, commentsEntity } from "./commentsActions";

const PREFIX = 'roblox';

const processStrategy = (value: any) => {
  return {
    ...value
  };
}

const reportsEntity = new schema.Entity(
  'reports',
  {
    user: usersEntity,
    active_user: usersEntity,
    skin: skinsEntity,
    comment: commentsEntity,
  },
  {
    processStrategy
  }
);

const reportEntity = new schema.Entity(
  'report',
  {
    user: usersEntity,
    active_user: usersEntity,
    skin: skinEntity,
    comment: commentEntity,
  },
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      user: { [key: string]: UserInterface };
      active_user: { [key: string]: UserInterface };
      skin: { [key: string]: SkinInterface };
      comment: { [key: string]: CommentInterface };
      report: ReportInterface;
    }
  >(response.data.report, reportEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized  = normalize<
    any,
    {
      reports: { [key: string]: ReportInterface },
      users: { [key: string]: UserInterface };
      active_users: { [key: string]: UserInterface };
      skins: { [key: string]: SkinInterface };
      comments: { [key: string]: CommentInterface };
    }
    >(response.data.reports, [reportsEntity]);

  return {
    reports: normalized.entities?.reports || {},
    users: normalized.entities.users || {},
    active_users: normalized.entities.active_users || {},
    skins: normalized.entities.skins || {},
    comments: normalized.entities.comments || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchReports = createAsyncThunk(
  `${PREFIX}_reports/fetchReports`,
  async (params: object = {}) => {
    const response = await robloxApi.get(`/onesky/reports`, { params })
    return normalizeCollection(response);
  }
);

export const fetchReport = createAsyncThunk(
  `${PREFIX}_reports/fetchReport`,
  async (id: number | string) => {
    const response = await robloxApi.get(`/onesky/reports/${id}`);
    return normalizeInstance(response);
  }
);

export const updateReport = createAsyncThunk(
  `${PREFIX}_reports/updateReport`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await robloxApi.patch(`/onesky/reports/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyReport = createAsyncThunk(
  `${PREFIX}_reports/destroyReport`,
  async (id: number) => {
    await robloxApi.delete(`/onesky/reports/${id}`);
    return { id: id };
  }
);
